import React from 'react';
import PortButton from '../PortButton';
import { enhancedTheme } from '../utils';

const chassisBadgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10px 20px',
  minWidth: 88,
  background: 'linear-gradient(180deg, #fafafa 0%, #e8e8e8 100%)',
  borderRadius: 4,
  border: '1px solid #bfbfbf',
  color: '#434343',
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: '0.02em',
  boxSizing: 'border-box',
  flexShrink: 0,
};

const Server2U = ({
  ports,
  selectedPortId,
  connectedPortIds,
  onPortClick,
  onRegisterAnchor,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      width: '100%',
      padding: '4px 8px',
      boxSizing: 'border-box',
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      <div style={chassisBadgeStyle}>2U Server</div>
      <span style={{ fontSize: 11, color: enhancedTheme.sectionLabel }}>
        Dual-unit chassis
      </span>
    </div>
    <div style={{ paddingLeft: 4, paddingRight: 4 }}>
      <div
        style={{
          fontSize: 11,
          color: enhancedTheme.sectionLabel,
          marginBottom: 8,
        }}
      >
        NIC / Port slots
      </div>
      {ports.length === 0 ? (
        <div
          style={{
            padding: '10px 14px',
            background: '#fafafa',
            border: '1px dashed #d9d9d9',
            borderRadius: 4,
            fontSize: 11,
            color: '#8c8c8c',
          }}
        >
          Link Device Registry and add Switch Port Registry rows to show ports
          here.
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', padding: '0 4px' }}>
          {ports.map((port, i) => (
            <PortButton
              key={port._id}
              port={port}
              slotNumber={i + 1}
              selected={String(selectedPortId) === String(port._id)}
              connected={connectedPortIds.has(String(port._id))}
              onClick={onPortClick}
              onRegisterAnchor={onRegisterAnchor}
              size={16}
            />
          ))}
        </div>
      )}
    </div>
  </div>
);

export default Server2U;
